<template>
  <div class="doc-field-container">
    <i
      class="material-icons delete-button"
      v-if="editable"
      @click="handleClickDeleteField()"
      >delete</i
    >
    <input
      :readonly="isDisable"
      type="text"
      v-if="field.type === 'Textbox'"
      v-model="field.value"
    />
    <textarea
      :readonly="isDisable"
      v-if="field.type === 'Textarea'"
      v-model="field.value"
    />
    <input
      :readonly="isDisable"
      type="radio"
      v-else-if="field.type === 'Radio'"
      :name="field.name"
      v-model="field.value"
    />
    <input
      :readonly="isDisable"
      type="checkbox"
      v-else-if="field.type === 'Checkbox'"
      v-model="field.value"
    />
    <input
      :readonly="true"
      type="text"
      v-else-if="field.type === 'Date Picker' && isDisable"
      :value="getDateString(new Date(field.value))"
    />
    <DatePicker
      v-else-if="field.type === 'Date Picker'"
      v-model="field.value"
      class="date-picker form-control registration-date"
      :append-to-body="true"
      default-panel="day"
    />
    <SignaturePad
      v-else-if="field.type === 'Signature'"
      v-model="field.value"
      height="100%"
      width="100%"
      :isViewOnly="isDisable"
    />
    <input
      :readonly="true"
      type="text"
      v-else-if="field.type === 'Pre-filled Value'"
      v-model="field.value"
    />
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import SignaturePad from "./SignaturePad.vue";

export default {
  name: "DocumentField",
  components: {
    DatePicker,
    SignaturePad,
  },
  props: {
    field: Object,
    isDisable: {
      type: Boolean,
      default: false,
    },
    user: Object,
    editable: Boolean,
  },
  created() {
    if (
      this.field &&
      this.field.type === "Pre-filled Value" &&
      this.field.model
    ) {
      if (this.field.model === "date") {
        this.field.value = this.getDateString(new Date());
      }
      if (this.user[this.field.model]) {
        this.field.value = this.user[this.field.model];
      }
    }
  },
  methods: {
    handleClickDeleteField() {
      this.showConfirmDialog({
        key: "DELETE_FIELD_CONFIRM_DIALOG",
        onAcceptCallback: () => {
          this.$emit("delete");
        },
      });
    },
  },
};
</script>
<style scoped>
.doc-field-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.delete-button {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

.doc-field-container > *:not(.delete-button) {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/documents/DocumentField.vue